import { Observable } from 'rxjs';

export enum SortOrder {
	asc = 'ASC',
	desc = 'DESC',
}

export interface SortColumn {
	columnName: string;
	sortOrder: SortOrder;
}

export interface DataRequestOption<FilterType = {}> {
	limit: number | null;
	page: number | null;
	filters: FilterType;
	sortColumn?: SortColumn;
}

export type ApiResponse<DataType> = {
	totalCount: number;
	pageIndex: number;
	pageSize: number;
	items: DataType[];
};

export interface Api<DataType, FilterType = {}> {
	get(request: DataRequestOption<FilterType>): Observable<ApiResponse<DataType>>;
}
